import React, {useContext, useEffect} from 'react';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import AdminLogin from './components/AdminLogin';
import Dashboard from './components/Dashboard';
import DriverList from './components/drivers/DriverList';
import './App.css';
import Header from './components/Header';
import {AuthContext} from './components/AuthContext';
import DriverProfile from './components/drivers/DriverProfile';
import Footer from './components/Footer';
import PickupList from './components/pickups/PickupList';
import PickupDetails from './components/pickups/PickupDetails';
import UserList from './components/users/UserList';
import UserProfile from './components/users/UserProfile';
import MyProfile from './components/MyProfile';
import SendNotification from './components/drivers/SendNotification';
import SendNotificationUser from './components/users/SendNotification';
import VehicleList from './components/vehicles/VehicleList';
import VehicleDetails from './components/vehicles/VehicleDetails';
import Managers from './components/managers/Managers';
import ManagerProfile from './components/managers/ManagerProfile';
import ManagerCreate from './components/managers/ManagerCreate';
import Permissions from './components/managers/Permissions';
import Roles from './components/managers/Roles';
import TruckTypePrices from './components/truck_types/TruckTypePrices';
import RoleDetails from './components/managers/RoleDetails';
import PermissionDetails from './components/managers/PermissionDetails';
import RoleCreate from './components/managers/RoleCreate';
import PermissionCreate from './components/managers/PermissionCreate';
import DriverPerformanceStatistics from './components/drivers/DriverPerformanceStatistics';
import UserPerformanceStatistics from './components/users/UserPerformanceStatistics';
import SalesReport from './components/sales/SalesReport';
import PickupStatisticsByDay from './components/pickups/PickupStatisticsByDay';
import UserSignupStatisticsByWeek from './components/users/UserSignupStatisticsByWeek';
import VehicleCreate from './components/vehicles/VehicleCreate';
import DriverCreate from './components/drivers/DriverCreate';
import {ConfigContext} from './components/ConfigContext';
import HeadConfig from './components/HeadConfig';
import UserCreate from './components/users/UserCreate';
import {Toaster} from 'react-hot-toast';
import PickupCreate from './components/pickups/PickupCreate';
import TaxRateList from "./components/tax-rates/TaxRateList";
import PickupLiveRequests from "./components/pickups/PickupLiveRequests";
import ManageBilling from "./components/ManageBilling";
import InvoiceList from "./components/invoices/InvoiceList";
import InvoiceDetails from "./components/invoices/InvoiceDetails";
import SchedulePickups from './components/pickups/schedule-pickups/SchedulePickups';
import PickupUpdate from './components/pickups/PickupUpdate';
import SlotPickups from './components/pickups/slots-pickup/SlotPickups';
import FleetLiveTracking from './components/fleet-tracking/FleetLiveTracking';

const App = () => {
    const {token, hasRole, hasPermission} = useContext(AuthContext);
    const config = useContext(ConfigContext);

    const primaryColor = config?.theme?.primaryColor || '#007bff';

    return (
        <>
            <HeadConfig/>
            <style>
                {`
                  .btn-primary {
                    background-color: ${primaryColor} !important;
                    border-color: ${primaryColor} !important;
                  }
                `}
            </style>
            <Router>
                <div className="App d-flex flex-column min-vh-100">
                    <Header token={token}/>
                    <div className="content">
                        <Routes>
                            <Route path="/" element={<AdminLogin/>}/>
                            <Route path="/dashboard" element={<Dashboard/>}/>

                            {hasPermission('driver-view') && (
                                <>
                                    <Route path="/drivers" element={<DriverList/>}/>
                                    <Route path="/fleet-live-tracking" element={<FleetLiveTracking/>}/>
                                    <Route
                                        path="/drivers/:driverId"
                                        element={<DriverProfile/>}
                                    />
                                    <Route path="/drivers/create" element={<DriverCreate/>}/>
                                    <Route
                                        path="/drivers/performance"
                                        element={<DriverPerformanceStatistics/>}
                                    />
                                </>
                            )}
                            {hasPermission('driver-update') && (
                                <>
                                    <Route
                                        path="/drivers/notify-all"
                                        element={<SendNotification/>}
                                    />
                                </>
                            )}

                            {hasPermission('pickup-view') && (
                                <>
                                    <Route path="/pickups" element={<PickupList/>}/>
                                    <Route path="/pickups/live-requests" element={<PickupLiveRequests/>}/>
                                    <Route path="/schedule-pickups" element={<SchedulePickups />} />
                                    <Route path="/slot-pickups" element={<SlotPickups />} />
                                    <Route path="/pickups/create/:userId" element={<PickupCreate/>}/>
                                    <Route path="/pickups/:pickupId" element={<PickupDetails/>}/>
                                    <Route path="/pickups/statistics/by_day" element={<PickupStatisticsByDay/>}/>
                                </>
                            )}

                            {hasPermission('pickup-update') && (
                                    <Route path="/pickups/update/:pickupId" element={<PickupUpdate/>}/>
                            )}

                            {hasPermission('sales-view') && (
                                <Route path="/pickups/sales" element={<SalesReport/>}/>
                            )}

                            {hasPermission('user-view') && (
                                <>
                                    <Route path="/users" element={<UserList/>}/>
                                    <Route path="/users/create" element={<UserCreate/>}/>
                                    <Route path="/users/:userId" element={<UserProfile/>}/>
                                    <Route
                                        path="/users/performance"
                                        element={<UserPerformanceStatistics/>}
                                    />
                                    <Route
                                        path="/users/statistics/signups/by_week"
                                        element={<UserSignupStatisticsByWeek/>}
                                    />
                                </>
                            )}
                            {hasPermission('user-update') && (
                                <>
                                    <Route
                                        path="/users/notify-all"
                                        element={<SendNotificationUser/>}
                                    />
                                </>
                            )}

                            <Route path="/my-profile" element={<MyProfile/>}/>

                            {hasRole("super-manager") && (
                                <Route path="/manage-billing" element={<ManageBilling/>}/>
                            )}

                            {hasPermission('vehicle-view') && (
                                <>
                                    <Route path="/vehicles" element={<VehicleList/>}/>
                                    <Route path="/vehicles/create" element={<VehicleCreate/>}/>
                                    <Route
                                        path="/vehicles/:vehicleId"
                                        element={<VehicleDetails/>}
                                    />
                                </>
                            )}

                            {/*  {hasPermission('cargo-insurance-view') && <Route path="/cargo-insurances" element={<CargoInsuranceList/>}/>}*/}
                            {hasPermission('truck-type-view') && (
                                <Route
                                    path="/truck-types/prices"
                                    element={<TruckTypePrices/>}
                                />
                            )}
                            {hasPermission('tax-rate-view') && <Route path="/tax-rates" element={<TaxRateList/>}/>}

                            {hasPermission('invoice-view') && (
                                <>
                                    <Route path="/invoices" element={<InvoiceList/>}/>
                                    <Route path="/invoices/:invoiceId" element={<InvoiceDetails/>}/>
                                </>
                            )}

                            {hasRole('super-manager') && (
                                <>
                                    <Route path="/managers" element={<Managers/>}/>
                                    <Route
                                        path="/managers/:managerId"
                                        element={<ManagerProfile/>}
                                    />
                                    <Route path="/managers/create" element={<ManagerCreate/>}/>
                                    <Route path="/managers/roles" element={<Roles/>}/>
                                    <Route
                                        path="/managers/roles/:roleId"
                                        element={<RoleDetails/>}
                                    />
                                    <Route
                                        path="/managers/roles/create"
                                        element={<RoleCreate/>}
                                    />
                                    <Route
                                        path="/managers/permissions"
                                        element={<Permissions/>}
                                    />
                                    <Route
                                        path="/managers/permissions/:permissionId"
                                        element={<PermissionDetails/>}
                                    />
                                    <Route
                                        path="/managers/permissions/create"
                                        element={<PermissionCreate/>}
                                    />
                                </>
                            )}
                        </Routes>
                    </div>
                    <Footer/>
                    <Toaster/>
                </div>
            </Router>
        </>
    );
};

export default App;
